import { render, staticRenderFns } from "./UsersTableMenu.vue?vue&type=template&id=577f91c2&scoped=true&"
import script from "./UsersTableMenu.vue?vue&type=script&lang=js&"
export * from "./UsersTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f91c2",
  null
  
)

export default component.exports